import type { File as SlabFile } from './api/File/File';

// Mirrors backend domain.FileEntityType (internal/domain/file.go).
export enum FileEntityType {
  Quote = 'quote',
  Project = 'project',
  Product = 'product',
  Company = 'company',
  Contact = 'contact',
}

// Not derivable by appending "s": company maps to /companies.
const FILE_ENTITY_PATH_SEGMENTS: Record<FileEntityType, string> = {
  [FileEntityType.Quote]: 'quotes',
  [FileEntityType.Project]: 'projects',
  [FileEntityType.Product]: 'products',
  [FileEntityType.Company]: 'companies',
  [FileEntityType.Contact]: 'contacts',
};

export const fileEntityPathSegment = (entityType: FileEntityType): string =>
  FILE_ENTITY_PATH_SEGMENTS[entityType];

export enum UploadItemStatus {
  Rejected = 'rejected',
  Uploading = 'uploading',
  Registering = 'registering',
  Done = 'done',
  Failed = 'failed',
}

export type UploadItem = {
  id: string;
  fileName: string;
  sizeBytes: number;
  progress: number;
  status: UploadItemStatus;
  errorMessage?: string;
  storageKey?: string;
  file?: SlabFile;
  isSensitive?: boolean;
};
